/* eslint-disable */

import * as destinationDeliveryService from "../../../../services/destinationDelivery";
import * as destinationPackageDeliveryService from "../../../../services/destinationPackageDelivery";
import * as settings from "../../../../services/settings";

import { Button, Form, InputNumber, Modal, Select, Spin, notification } from "antd";
import React, { useState } from "react";

import { useAccessToken } from "../../../../contexts/AccessTokenContext";
import { useEffect } from "react";
import { validateSubmitCreateDestinationDeliveryForPackage } from "../../../../Components/validations/validateCreateDestinationDelivery";

const pendingDestinationPackageForCreateByKey = new Map();

export const ModalCreateDestinationDeliveryPackage = ({
  t,
  type,
  isModalOpen,
  handleCancel,
  getListDestinationDeliveryPackage,
  editDestinationDeliveryPackageData,
  detailData,
  setIsModalOpen,
  isEdit,
  setIsCreate,
  destinationPackageDelivery,
}) => {
  const { accessToken } = useAccessToken();
  const [loading, setLoading] = useState(false);
  const [formDestinationPackage] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  // DestinationPackage
  const [pageDP, setPageDP] = useState(1);
  const [totalDP, setTotalDP] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [destinationPackage, setDestinationPackage] = useState([]);
  const [totalRecieved, setTotalReceived] = useState(0);
  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const getListDestinationPackage = async (pageDP, searchData) => {
    const params = { page: pageDP, limit: 20, reference: searchData };
    const requestKey = JSON.stringify(params);
    const existing = pendingDestinationPackageForCreateByKey.get(requestKey);
    if (existing) {
      return existing;
    }

    const promise = (async () => {
      setLoading(true);
      setDestinationPackage([]);
      let resDestinationPackage = [];
      try {
        const data = await destinationDeliveryService.getDestinationPackageForCreate(accessToken, params);
        if (data) {
          data.queryListDestinationPackage.map((value) => {
            resDestinationPackage.push({
              value: value.id,
              label: value.reference,
            });
          });

          setDestinationPackage((prevOptions) => [...prevOptions, ...resDestinationPackage]);
          setTotalDP(data.totalCount);
          setPageDP(pageDP);
        }

        setLoading(false);
      } catch (err) {
        console.error("[ModalCreateDestinationDeliveryPackage] getListDestinationPackage: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      } finally {
        pendingDestinationPackageForCreateByKey.delete(requestKey);
      }
    })();

    pendingDestinationPackageForCreateByKey.set(requestKey, promise);
    return promise;
  };

  // Filter search from select
  const handleSearch = async (value) => {
    let searchNewPage = pageDP;
    // Check if value is undefined and value not equal to searchData set searchData is 1 default
    if (!value) {
      searchNewPage = 1;
      setPageDP(1);
      setSearchData("");
    } else if (value !== searchData) {
      setPageDP(1);
      searchNewPage = 1;
      setSearchData("");
    }

    setSearchData(value);
    await getListDestinationPackage(searchNewPage, value);
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  // Scroll data to call api pagination
  const handlePopupScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.clientHeight === target.scrollHeight) {
      getListDestinationPackage(pageDP + 1, searchData);
    }
  };

  const onSubmitDestinationDelivery = async () => {
    const values = await formDestinationPackage.getFieldsValue();
    const { package_service } = values || {};
    let destinationDeliveryData = type === "EDIT" ? destinationPackageDelivery.id : detailData.id;
    const { isValid } = validateSubmitCreateDestinationDeliveryForPackage(values);
    if (isValid) {
      const prepareData = {
        destination_package_id: package_service,
        destination_delivery_id: destinationDeliveryData,
        total_received: totalRecieved,
      };
      let response;
      try {
        if (isEdit) {
          prepareData.id = editDestinationDeliveryPackageData.id;
          if (typeof package_service === "string") {
            prepareData.destination_package_id = editDestinationDeliveryPackageData.destination_package_id;
          }
          response = await destinationPackageDeliveryService.updateDestinationDeliveryPackage(accessToken, prepareData);
          openNotificationWithIcon(
            settings.NotificationType.SUCCESS,
            <>{"Success."}</>,
            <>{"Update destination delivery package success"}</>
          );
        } else {
          response = await destinationPackageDeliveryService.createDestinationDeliveryPackage(accessToken, prepareData);
          openNotificationWithIcon(
            settings.NotificationType.SUCCESS,
            <>{"Success."}</>,
            <>{"Create destination delivery package success"}</>
          );
        }
        setIsModalOpen(false);
        getListDestinationDeliveryPackage(response);
        setIsCreate(true);
        setLoading(false);
      } catch (err) {
        console.error("[ModalCreateDestinationDeliveryPackage] onSubmitDestinationDelivery: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        setLoading(false);
      }
    } else {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        <>{"ERROR."}</>,
        <>{`Please check data is request create/update destination delivery package`}</>
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!accessToken || !isModalOpen) return;
    getListDestinationPackage(pageDP);
    formDestinationPackage.resetFields();
    if (isEdit) {
      formDestinationPackage.setFieldValue(
        "package_service",
        editDestinationDeliveryPackageData.app_destinationpackage.reference
      );
      formDestinationPackage.setFieldValue("total_received", editDestinationDeliveryPackageData.total_received);
      setTotalReceived(editDestinationDeliveryPackageData?.total_received);
    }
  }, [accessToken, isEdit, formDestinationPackage, isModalOpen, editDestinationDeliveryPackageData?.id]);

  return (
    <>
      {contextHolder}
      <Modal
        title={t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Title_Package")}
        open={isModalOpen}
        className="rounded-lg border-2"
        closable={true}
        centered={true}
        forceRender={true}
        onCancel={handleCancel}
        style={{ justifyContent: "center" }}
        width={620}
        footer={() => (
          <>
            <Button type="primary" onClick={onSubmitDestinationDelivery}>
              {t("BTN_Save", { ns: "buttons" })}
            </Button>
            <Button onClick={handleCancel}>{t("BTN_Cancel", { ns: "buttons" })}</Button>
          </>
        )}
      >
        <Spin spinning={loading}>
          <div className="mt-6">
            <Form
              form={formDestinationPackage}
              labelAlign="center"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              initialValues={{
                package_service: editDestinationDeliveryPackageData?.package_service,
                total_received: editDestinationDeliveryPackageData?.total_received,
              }}
            >
              <Form.Item
                label={t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Title_Package") + ":"}
                name="package_service"
                key="package_service"
                style={{ marginBottom: "1rem" }}
                rules={[{ required: true }, { validator: validateSubmitCreateDestinationDeliveryForPackage }]}
              >
                <Select
                  disabled={isEdit}
                  style={{ width: "100%" }}
                  showSearch
                  placeholder={"Please Select Package"}
                  allowClear
                  options={destinationPackage}
                  loading={loading}
                  onPopupScroll={handlePopupScroll}
                  onSearch={handleSearch}
                  filterOption={filterOption}
                  notFoundContent={loading ? <Spin size="small" /> : null}
                />
              </Form.Item>
              {/* Form total_received */}
              <Form.Item
                label={t("Destination_Delivery_Create.Create_Destination_Delivery_Package.Table_Total_Received") + ":"}
                name="total_received"
                key="total_received"
                rules={[{ required: true }]}
                hasFeedback
              >
                <InputNumber
                  defaultValue={1}
                  style={{ width: "100%" }}
                  min="1"
                  onChange={(values) => {
                    setTotalReceived(values);
                  }}
                />
              </Form.Item>
            </Form>
          </div>
        </Spin>
      </Modal>
    </>
  );
};
